export function subStrFilter(str,start, end) {
   if(str && str.length>end){
       str =  str.substring(start,end) + "...";
   }
   return str;
}
export function nvl(source,target) {
   if(!source){
        return target;
   }
   return source;
}
